import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const usePageNumber = () => {

  const [searchParams, setSearchParams] = useSearchParams()
  const [page, setPage] = useState(() => parseInt(searchParams.get('page') || '1', 10) - 1)

  useEffect(() => {
    setSearchParams((searchParams) => {
      if (page === 0) {
        searchParams.delete('page')
      } else {
        searchParams.set('page', String(page + 1))
      }
      return searchParams
    }, { replace: true })
  }, [page])

  return { page, handlePageChange: setPage }
}
